import PaginatorItem from './Paginator.Item';
import PaginatorItemBack from './Paginator.ItemBack';
import PaginatorItemForward from './Paginator.ItemForward';
import { PaginatorProvider } from './PaginatorContext';
import './_paginator.scss';
import './_paginator-dots.scss';
import PaginatorItemDots from './Paginator.ItemDots';

export default function Paginator({ variant = 'default', className = null, children = null }) {
  return (
    <div className={`Paginator Paginator__${variant} ${className || ''}`}>
      <div className="Paginator__track">{children}</div>
    </div>
  );
}

Paginator.Item = PaginatorItem;
Paginator.ItemDots = PaginatorItemDots;
Paginator.ItemBack = PaginatorItemBack;
Paginator.ItemForward = PaginatorItemForward;
Paginator.Provider = PaginatorProvider;
